/**
 * Created by seaasun on 2017/11/24.
 */
import Vue from 'vue'
// import utils from '@/assets/utils/index'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    currentCategory: 0,
    isInit: false,
    categories: [{
      Id: 0,
      Active: true,
      CategoryDesc: 'All',
      CategoryName: 'All'
    }],
    histories: [],
    point: {
      AvailablePoints: 0,
      BonusPoints: 0,
      EarnedPoints: 0,
      RedeemedPoints: 0
    },
    carts: [],
    items: {
      0: []
    }
  },
  getters: {
    cartPoint (state) {
      let total = 0
      for (let item of state.carts) {
        total += item.DesiredQuantity * item.PointForOne
      }
      return total
    },
    cartNumber (state) {
      let total = 0
      for (let item of state.carts) {
        total += item.DesiredQuantity
      }
      return total
    }
  },
  mutations: {
    saveKey (state, val) {
      Vue.set(state, val[0], val[1])
    },
    saveItems (state, val) {
      Vue.set(state.items, val[0], val[1])
    },
    updateCart (state, paylod) {
      let index = _.findIndex(state.carts, item => {
        return item.GiftId === paylod.Id
      })
      if (index === -1) {
        state.carts.push({
          CategoryId: paylod.GiftCategoryId,
          DesiredQuantity: paylod.quantity,
          GiftId: paylod.Id,
          GiftName: paylod.GiftName,
          PointForOne: paylod.GiftPoint,
          image: paylod.GiftImage
        })
      } else {
        if (paylod.isUpdated) {
          state.carts[index].DesiredQuantity = paylod.quantity
        } else {
          state.carts[index].DesiredQuantity += paylod.quantity
        }
        if (state.carts[index].DesiredQuantity <= 0) {
          Vue.delete(state.carts, index)
        }
      }
    }
  },
  actions: {
    init ({commit}) {
      if (this.isInit) {
        return false
      }
      Vue.http.post('ba/Reward.aspx/GetInitReward', {
        availablePoints: 0,
        categoryId: 0,
        isDesc: false,
        onlyEligible: false,
        pageIndex: 1,
        pageSize: 100
      }).then(resp => {
        let data = resp.body.d.DataSource
        commit('saveKey', ['isInit', true])
        commit('saveKey', ['categories', data.Categories])
        commit('saveKey', ['histories', data.Histories])
        commit('saveKey', ['point', data.Point])
        commit('saveItems', [0, data.RewardDetailList.Items])
      })
    },
    getItem ({commit}, id) {
      Vue.http.post('ba/Reward.aspx/GetRewards', {
        availablePoints: 0,
        categoryId: id,
        isDesc: false,
        onlyEligible: false,
        pageIndex: 1,
        pageSize: 100
      }).then(resp => {
        let data = resp.body.d.DataSource
        commit('saveItems', [id, data.Items])
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reward/index.js